import { useQuery } from '@tanstack/react-query';

import { PLAYER_PROFILE_STATS_KEY } from '@/hooks/player-details/constants';
import { getPlayerProfileStats } from '@/infrastructure/network/data/player-details/player-profile-stats';
import { useOrganizationStore } from '@/store/organization-store';

export const usePlayerProfileStatsQuery = (teamLeagueUuid: string, playerUuid: string, seasonUuid?: string | null) => {
	const store = useOrganizationStore();
	return useQuery({
		queryKey: [PLAYER_PROFILE_STATS_KEY, store.organizationUuid, teamLeagueUuid, playerUuid, seasonUuid],
		queryFn: () => getPlayerProfileStats({ organizationUuid: store.organizationUuid, teamLeagueUuid, playerUuid, seasonUuid }),
		enabled: !!(store.organizationUuid && teamLeagueUuid && playerUuid)
	});
};
